import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { Paper, Button, Table, TableBody, Checkbox, TableCell, TableHead, TableRow, TableSortLabel, Grid } from "@mui/material";
import DeletePopUp from "../../../../shared_elements/components/DeletePopUp";
import { SupplementCRU, SupplementList } from "../components";
import { LeasesMenuList, LeasesNav } from "../../../elements";
import { Pagination, STableLoader, PageLoader } from "../../../../shared_elements";
import { globalDeleteService, globalGetService } from "../../../../utils/globalApiServices";
import { getSupplementsApi, deleteSupplementApi } from "../apiServices";
import { checkApiStatus } from "../../../../utils";
import NoRecordFound from "../../../../shared_elements/NoRecordFound";
import { useSnackbar } from "notistack";
import { ButtonLoader, ShowAttachments } from "../../../../shared_elements/components";
import { PermissionWrapper } from "../../../../wrappers";
import { RoleBaseAccess } from "../../../../hoc";
import LeasesBasicDetails from "../../../elements/LeasesBasicDetails";
import { trackActivity } from "../../../../utils/mixpanel";
import FileUploadLayout from "../../../../shared_elements/components/FileUploadLayout";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { getStorage } from "../../../../shared_elements/actionCreators";
import RevisionHistory from "../../../../shared_elements/components/RevisionHistory";
import ModuleWiseRevisionHistory from "../../../../shared_elements/components/ModuleWiseRevisionHistory";
import fileUpload, { getApiResponse } from "../../../../utils/fileUpload";
import BackToLeaseList from "../../../elements/BackToLeaseList";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const TABLE_HEIGHT = 'calc(100vh - 238px)';

const SupplementHd = ({ createSortHandler, sortInfo, toggleBulkOps, item, bulk }) => {
  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Supplement`, page_type: page_type, })
  }
  const tableSorting = (key, name) => (
    <TableSortLabel
      sx={{ whiteSpace: "nowrap" }}
      active={sortInfo?.sort_by === key}
      direction={sortInfo?.sort_by === key ? sortInfo.sort : 'asc'}
      onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
    >
      <span style={{ color: sortInfo?.sort_by === key ? '#496ac5' : 'inherit' }}>
        {name}
      </span>
    </TableSortLabel>
  );

  return (
    <TableHead>
      <TableRow>
        <TableCell className="table-actions-header" sx={{ width: 140, whiteSpace: "nowrap" }}>
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "supplement", operationType: ['D'] }}>
            <Checkbox disableRipple color="primary" size="small" onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item, item)} checked={item?.length === bulk?.ids?.length && item?.length > 0} />
          </PermissionWrapper>
          Action(s)
        </TableCell>
        <TableCell sx={{ minWidth: "100px", whiteSpace: "nowrap" }}>{tableSorting("date", "Supplement Date")}</TableCell>
        <TableCell sx={{ minWidth: "100px", whiteSpace: "nowrap" }}>{tableSorting("unique_identifier", "Supplement Number")}</TableCell>
        <TableCell sx={{ minWidth: '100px', whiteSpace: "nowrap" }}>{tableSorting("executed_by", "Executed By")}</TableCell>
      </TableRow>
    </TableHead>
  );
};

const Supplement = () => {
  const dispatch=useDispatch()
  const {fileUploadDetails} = useSelector((state) => state.leases);
  const { enqueueSnackbar } = useSnackbar();
  const { leaseSlug } = useParams();
  const params = { leaseSlug };
  const [isLoading, setLoading] = useState(false);
  const [skeletonLoader, setSkeletonLoader] = useState(false);
  const [supplementInfo, setSupplementInfo] = useState({ list: [], pagination: null });
  const [addEditSupplement, setAddEditSupplement] = useState({ mode: '', modal: false, data: null });
  const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' });
  const [deleteSupplements, setDeleteSupplements] = useState({ modal: false, data: null, })
  const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
  const [attachments, setAttachments] = useState({ modal: false, data: null, mode:'' })
  const[isExport,seIsExport]=useState(false)
  const[uploadFileProgressData,setUploadFileProgressData]=useState({})
  const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
  const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
  const [slug,setSlug]=useState({})

  useEffect(() => {
    const uploadedFileData = getApiResponse("supplement", slug);
    getSupplementList('skeletonLoader', { per_page: 50 });
    trackActivity('Page Viewed',{ page_title: 'Supplement'})
    setUploadFileProgressData({uploadedFileData});
  }, []);

  const getSupplementList = (loaderType, query = {}) => {
    loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
    globalGetService(getSupplementsApi(params, query)).then(response => {
      if (checkApiStatus(response)) {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
        setSupplementInfo(response.data.data);
      } else {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
      }
    })
    dispatch(getStorage({lease_slug:params?.leaseSlug,module_name:"supplement"}))
  };

  const createSortHandler = (key) => {
    let sortQuery = { sort_by: key };
    if (sortInfo.sort_by === key) {
      sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' }
    } else {
      sortQuery = { ...sortQuery, sort: 'asc' }
    }
    setSortInfo(sortQuery)
    getSupplementList("", {
      ...sortQuery,
      page: supplementInfo?.pagination?.current_page || 1,
      per_page: supplementInfo?.pagination?.per_page || 20,
    })
  }

  const onDeleteSupplements = () => {
    const idsToDelete = deleteSupplements?.modal && deleteSupplements?.data?.id ? [deleteSupplements?.data?.id] : (bulk?.ids || []).map(item => item?.id);
    setLoading(true);
    globalDeleteService(deleteSupplementApi(params),
      { ids: idsToDelete }
    )
      .then(response => {
        if (checkApiStatus(response)) {
          trackActivity('Item Deleted', { page_title: `Delete Supplement`, success_msg: response?.data?.message, item_ids: deleteSupplements?.data || bulk?.ids, response: response?.data })
          setDeleteSupplements({ modal: false, data: null });
          setBulk({ modal: false, ids: [], wrkGrpSlug: '' })
          setLoading(false);
          enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
          getSupplementList("", {
            page: supplementInfo?.pagination?.current_page || 1,
            per_page: supplementInfo?.pagination?.per_page || 50,
          })
        } else {
          setLoading(false);
          enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
          trackActivity('Item Deleted', { page_title: `Delete Supplement`, error_msg: response?.data?.message, item_ids: deleteSupplements?.data || bulk?.ids, response: response?.data })
        }
      })
  }

  const toggleBulkOps = (flag, type, item) => {
    if (type === 'bulk') {
      setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] });
    } else {
      setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
    }
  }

  const onDeteAttchments = (deltedslug) => {
    setAttachments({
      ...attachments, data: {
        ...attachments.data,
        attachments: attachments.data.attachments.filter(item => item.slug !== deltedslug)
      }
    });
    if (addEditSupplement?.modal) {
      setAddEditSupplement({
        ...addEditSupplement,
        data: {
          ...addEditSupplement.data,
          attachments: addEditSupplement.data.attachments.filter(item => item?.slug !== deltedslug)
        }
      })
    }
    getSupplementList('', { per_page: supplementInfo?.pagination?.per_page || 50 });
  }

  const handleExport=()=>{
    let query = { export: true }
    if (sortInfo?.sort && sortInfo?.sort_by) {
      query = {
        ...query,
        sort: sortInfo?.sort,
        sort_by: sortInfo?.sort_by
      }
    }
      seIsExport(true);
      globalGetService(getSupplementsApi( params, query)).then((response)=>{
          if (checkApiStatus(response)){
            enqueueSnackbar(
                   response?.data.message,
                   { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
                 );
                  seIsExport(false);
          }
      })
  }


  const handleUpload = async (slug, mode) => {
    setSlug({slug:slug})
    await fileUpload({
    attachments: fileUploadDetails.attachments,
    module_name: "supplement",
    slug: slug,
    query: { record_action_type: mode },
    onStart: () => setLoading(true),
    onComplete: () => setLoading(false),
    onProgress: ({ progressRefs, attachments ,response}) => {
        setUploadFileProgressData({ progressRefs, attachments ,response});
    },
    onSuccess: (success_msg) => {
    enqueueSnackbar(success_msg, { variant: "success" });
    getSupplementList("", { per_page: supplementInfo?.pagination?.per_page || 50 });
   },
    onError: (err) => {
      enqueueSnackbar(`${err?.message}` || "Error while uploading files", { variant: "error" });
    }
    });
      setSlug({})
    };
    const handleItemClicked = (page_type) => {
      trackActivity('Item Clicked', { page_title: `Supplement`, page_type: page_type, })
    }

  return (
    <>
      <LeasesBasicDetails />
      <Paper className="lease-details-section section-overflow lease-module-paper" elevation={0}>
        <LeasesNav type="basic"/>
        <div className='lease-details-content contnet-overflow'>
          <Paper square className="responsive-paper">
            <Grid container className="responsive-grid" alignItems='flex-end'>
              <Grid item size={{ md: 12, xs: 12 }} className="menu-container">
                <LeasesMenuList btnText="Supplement" type="basic" />
              </Grid>
              <Grid item size={{ md: 6, xs: 12 }} className="menu-container">
                <BackToLeaseList />
              </Grid>
              <Grid item size={{ md: 6, xs: 12 }}>
                <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding: '0px', float: 'right' }}>
                    <li className="lease-mobile-button revision-history"><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: {slug:params?.leaseSlug,type:"global"} })}/> </li> {
                    bulk?.type && bulk?.ids?.length ?
                      <>
                        <li className='lease-mobile-button'>
                          <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary" >Cancel</Button>
                        </li>
                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "supplement", operationType: ['D'] }}>
                          <li className='lease-mobile-button'>
                            <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button') }} variant="contained" size="small" color='error'>{`Delete (${bulk?.ids?.length})`}</Button>
                          </li>
                        </PermissionWrapper>
                      </> : null
                  }
                  {supplementInfo?.list?.length > 0 ? <li className='lease-mobile-button'> <Button startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} onClick={() => { handleExport(); handleItemClicked('Export Button') }} variant="outlined" size='small' className='btn-primary action-btn-start-icon'> Export </Button> </li> : null}
                  <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "supplement", operationType: ['C'] }}>
                    <li className='lease-mobile-button'> <Button variant="contained" color="primary" size='small' className='btn-primary action-btn-start-icon' onClick={() => { setAddEditSupplement({ modal: true, data: { date: null, unique_identifier: '', executed_by: '', slug: "" }, mode: 'add' }); handleItemClicked('Add Item Button') }} startIcon={<AddOutlinedIcon />}> Add Supplement </Button> </li>
                  </PermissionWrapper>
                </ul>
              </Grid>
            </Grid>
          </Paper>          
          <Paper className='lease-detail-table table-container lease-module-paper' elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: TABLE_HEIGHT, height: supplementInfo?.list?.length > 0 ? `${TABLE_HEIGHT} !important` : 'auto !important' }}>
            <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
              {skeletonLoader ? <STableLoader count={4} rowCount={11} /> : (
                <Table className="mui-table-format" stickyHeader>
                  <SupplementHd sortInfo={sortInfo} createSortHandler={createSortHandler} bulk={bulk} item={supplementInfo?.list} toggleBulkOps={toggleBulkOps} />
                  <TableBody>
                    {supplementInfo?.list?.length > 0 && supplementInfo?.list?.map((item, index) =>{
                        const uploadedFileData = getApiResponse("supplement", item?.slug);

                      return (
                        <SupplementList
                          slug={slug?.slug}
                          uploadedFileData={uploadedFileData }
                          uploadFileProgressData={uploadFileProgressData}
                          viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                          key={index}
                          item={item}
                          bulk={bulk}
                          viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                          onEditFn={() => setAddEditSupplement({ modal: true, data: item, mode: 'edit' })}
                          onView={() => setAddEditSupplement({ modal: true, data: item, mode: 'view' })}
                          onDeleteEolFn={() => {
                            setBulk({ modal: false, ids: [item], title: '', type: '' });
                            setDeleteSupplements({ modal: true, data: item, });
                          }}
                          toggleBulkOps={(e) => toggleBulkOps(e.target.checked, 'single', item)}
                          onOpenAttachments={() => setAttachments({ modal: true, data: item })}
                        />
                      )
                    }
                    )}
                  </TableBody>
                </Table>
              )}
              {!skeletonLoader && !supplementInfo?.list?.length && <NoRecordFound />}
            </div>
            <Paper square>
              <Pagination
                pagination={supplementInfo?.pagination} onPageChange={(event, newPage) => { const pageNum = newPage + 1; getSupplementList("Pageloader", { page: pageNum, per_page: supplementInfo?.pagination?.per_page, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }} onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getSupplementList("Pageloader", { page: 1, per_page: perPage, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }}
              />
            </Paper>
          </Paper>
        </div>
      </Paper>
      {
        addEditSupplement.modal && (
          <SupplementCRU
            fileUpload={handleUpload}
            addEditSupplement={addEditSupplement}
            modeType={addEditSupplement?.mode}
            getResponseBack={() => {getSupplementList('fetch', { per_page: supplementInfo.pagination.per_page }); setBulk({modal: false, ids: [], type: '', title: ''})}}
            onOpenAttachments={() => setAttachments({ modal: true, data: addEditSupplement?.data, mode:'view' })}
            onToggleModal={() => setAddEditSupplement({ modal: false, data: null, mode: '' })}
          />
        )
      }

      {deleteSupplements.modal &&
        <DeletePopUp
          modal={deleteSupplements.modal}
          title='Delete Supplement'
          content={`Are you sure, you want to Delete?`}
          onToggleModal={() => {
            setDeleteSupplements({ modal: false, data: null });
            setBulk({ modal: false, ids: [], title: '' });
          }}
          onDeleteRecords={() => onDeleteSupplements()}
        />}
      {attachments.modal ?
        <ShowAttachments
          moduleName="Supplement"
          url='delete-attachment'
          attachmentsData={attachments}
          getResponseBack={onDeteAttchments}
          toggleModalFn={() => setAttachments({ modal: false, data: null, mode:'' })}
          onViewDisabled={addEditSupplement?.mode === 'view' || attachments?.mode==='view'}
          permissionKey='supplement'
        /> : null
      }
      {bulk.modal ?
        <DeletePopUp
          modal={bulk.modal}
          title={`Delete ${bulk?.type === 'bulk' && bulk?.ids?.length > 0 && bulk?.ids?.length === (supplementInfo?.list?.length || 0) ? "All Supplements" : "Selected Supplements"}`}
          onDeleteRecords={() => onDeleteSupplements()}
          content={`Are you sure, you want to Delete ${bulk?.ids.length > 1 ? 'these' : 'this'} record ?`}
          onToggleModal={() => setBulk({ modal: false, ids: [] })}
        /> : null
      }
        <FileUploadLayout
          uploadFileStatus={uploadFileStatus}
          open={uploadFileStatus?.modal}
          setUploadFileStatus={setUploadFileStatus}
          uploadFileProgressData={uploadFileProgressData}
          progressRefs={uploadFileProgressData?.progressRefs}
          attachments={uploadFileProgressData?.attachments}
          onDownloadComplete={()=> setSlug({})}
        />

      {
        revisionHistory.modal &&  
          <RevisionHistory 
            moduleName={"supplement"}
            revisionHistory={revisionHistory}
            onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
          />
      }
      {isLoading ? <PageLoader /> : null}
    </>
  );

};

export default RoleBaseAccess(Supplement, { application: 'lease_revamp', feature: 'supplement', operationType: ['R'], leaseNav: true });
